import type { FaireProductEntity } from "../../entity_types/product";

export const p_kbq7tz52vc: FaireProductEntity = {
  token: "p_kbq7tz52vc",
  type: "product",
  name: "Boy Mom Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/c2a34220b5835cb455932c9d4b3c6a718611d59d65cbd771745d96af483960b5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7dcf4153a52d377aab8c3e506b1f1494ccee548cce9fa30cd60be91a6ae79df9.jpeg",
    "https://cdn.faire.com/fastly/edd5065d2753d085eedc581f8f2f13699e4bc08d4d9e45daf021dfe08b76e57e.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/3ec677c50a08f52bef426b88e375b9d362ddbe70cf9117cadcac8746b76ad6c3.jpeg",
    "https://cdn.faire.com/fastly/a1ce7dbe6b7cef4cd2d021cc85e8638dfd08bf7f9706342528dcfedfba114f50.jpeg",
    "https://cdn.faire.com/fastly/8b0c6b2c1f3426a7e099cbc43118cd6e0752b573bbd8816e5d26151be722ced7.jpeg",
    "https://cdn.faire.com/fastly/e7b1cc05d524a508cdfb338679df04d942f63536c3e35cb381cd16102829337c.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the mom who's learned to embrace chaos, sounds of gas escaping, and the myth of peace and quiet.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:28.640Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
